var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIconDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3.5,
    fill: "#797A7B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3.5,
    stroke: "#797A7B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2069 4.793C12.3944 4.98053 12.4997 5.23484 12.4997 5.5C12.4997 5.76516 12.3944 6.01947 12.2069 6.207L7.20692 11.207C7.01939 11.3945 6.76508 11.4998 6.49992 11.4998C6.23475 11.4998 5.98045 11.3945 5.79292 11.207L3.79292 9.207C3.61076 9.0184 3.50997 8.7658 3.51224 8.5036C3.51452 8.2414 3.61969 7.99059 3.8051 7.80518C3.99051 7.61977 4.24132 7.5146 4.50352 7.51233C4.76571 7.51005 5.01832 7.61084 5.20692 7.793L6.49992 9.086L10.7929 4.793C10.9804 4.60553 11.2348 4.50021 11.4999 4.50021C11.7651 4.50021 12.0194 4.60553 12.2069 4.793Z",
    fill: "#C9CDCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIconDisabled);
export default __webpack_public_path__ + "static/media/CheckedIconDisabled.4f1b73b0f2c39f385afd43d1ad485e2a.svg";
export { ForwardRef as ReactComponent };